"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _FilterText = require("../FilterText");
var _default = exports["default"] = {
  code: 'regex',
  component: _FilterText.Component,
  getCondition: function getCondition(field, value, settings) {
    var pattern = settings.preparePattern ? settings.preparePattern(value) : value;
    return {
      regex: {
        field: field,
        pattern: pattern
      }
    };
  }
};